var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.brand === 'saverium_dk')?_c('DanishConsent',{attrs:{"consentUrl":_vm.consentUrl}}):_vm._e(),(_vm.brand === 'saverium_pl')?_c('PolishConsent',{attrs:{"consentUrl":_vm.consentUrl}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }